import _styled from "styled-components";
type Props = {
  children: React.ReactNode;
};
export function DeepDiveGalleryControlDirection(props: Props & React.ComponentPropsWithoutRef<"button">) {
  const {
    children,
    ...rest
  } = props;
  return <_StyledButton {...rest} $_css={[{
    "display": "inline-flex",
    "height": "3.2rem",
    "width": "3.2rem",
    "flexShrink": "0",
    "alignItems": "center",
    "justifyContent": "center",
    "@media (min-width: 1024px)": {
      "height": "4.8rem",
      "width": "4rem"
    }
  }, {
    "borderRadius": "4px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 7 4 / var(--tw-bg-opacity))",
    "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
    "transitionDuration": "250ms",
    "transitionTimingFunction": "ease-in-out"
  }, {
    "&:disabled": {
      "backgroundColor": "transparent"
    },
    "@media (hover: hover)": {
      "&:hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(73 77 75 / var(--tw-bg-opacity))"
      }
    }
  }]}>
      {children}
    </_StyledButton>;
}
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "deep-dive-gallery-control-direction___StyledButton",
  componentId: "sc-edad3h-0"
})(["", ""], p => p.$_css);